import { arrayOf, string } from 'prop-types';

export const flagReasonsShape = arrayOf(arrayOf(string));

export default function getFlagReasons(flagReasonFilterOptions) {
  return flagReasonFilterOptions
    .filter((option) => option.id !== 'all')
    .map((option) => [option.id, option.label]);
}
